document.addEventListener('DOMContentLoaded', () => {
  const addToCartBtn     = document.getElementById('addToCart');
  const selector         = document.querySelector('select[name="id"]');
  const notifyWrapper    = document.getElementById('notifyMeWrapper');
  const variantNameField = document.getElementById('variantNameField');
  const form             = document.getElementById('notifyMeForm');
  const successMsg       = document.getElementById('notifySuccess');

  if (!addToCartBtn || !selector || !notifyWrapper || !variantNameField || !form) return;

  // --- Show/Hide Notify Form based on Add to Cart state ---
  function updateNotifyForm() {
    const isDisabled = addToCartBtn.disabled || addToCartBtn.classList.contains('disabled');
    const selectedOption = selector.options[selector.selectedIndex];
    const variantText = selectedOption?.textContent.trim() || '';

    if (isDisabled) {
      notifyWrapper.style.display = 'block';
      variantNameField.value = variantText.replace(/-?\s*sold\s*out/i, '').trim();
    } else {
      notifyWrapper.style.display = 'none';
      variantNameField.value = '';
      successMsg.style.display = 'none'; // hide success if switching back
    }
  }

  // Observe Add to Cart button for changes
  const observer = new MutationObserver(updateNotifyForm);
  observer.observe(addToCartBtn, { attributes: true, attributeFilter: ['class', 'disabled'] });

  // Also run on variant change (extra safety)
  selector.addEventListener('change', () => setTimeout(updateNotifyForm, 50));

  // Initial run
  updateNotifyForm();

  // --- Handle AJAX submission to n8n ---
  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const formData = new FormData(form);

    try {
      await fetch("https://kit0407.zeabur.app/webhook/ee6e2156-82e1-4110-b24e-20d1a0916199", {
        method: "POST",
        body: formData
      });

      // Show success message
      successMsg.style.display = 'block';

      // Clear the email field
      form.querySelector('input[name="email"]').value = '';
    } catch (err) {
      console.error("Notify form error:", err);
      alert("Something went wrong. Please try again.");
    }
  });
});

